<template>
  <div>
      <th-logo>
        <th-reddot :size="'8px'"/>
      </th-logo>
      <th-navigation-button :showmenu="showmenu" @update:menu="newValue => handleMenuState(newValue)"/>

      <th-navigation :showmenu="showmenu" @update:menu="newValue => handleMenuState(newValue)"/>
      <div class="offcanvas" ref="offcanvas">
        <router-view>
          <th-reddot :size="'30px'" />
        </router-view>
      </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { 
  gsap, TimelineMax, Power4, TweenMax, Power2, Back,
} from 'gsap/dist/gsap';
// import ScrollToPlugin from 'gsap/ScrollToPlugin';
// import ScrollMagic from 'scrollmagic';
// import './animation.gsap.modified';
// import './debug.addIndicators.modified';
// import helper from './helper';
/* eslint-enable no-unused-vars */

import ThNavigationButton from './components/ThNavigationButton.vue';
import ThNavigation from './components/ThNavigation.vue';
import ThLogo from './components/ThLogo.vue';
import ThReddot from './components/ThReddot.vue';

// gsap.registerPlugin(ScrollToPlugin);
export default {
  components: {
    ThNavigationButton,
    ThNavigation,
    ThLogo,
    ThReddot,
  },
  data() {
    return {
      showmenu: false,
    };
  },
  methods: {
    handleMenuState(newValue) {
      this.showmenu = newValue;
      // const canvasWidthPercent = helper.isMobile() ? 0 : 62;
      const bodyTL = new TimelineMax();
      if (this.showmenu) {
        bodyTL.fromTo(this.$refs.offcanvas, 1, { width: '100%' }, { width: '62%', ease: Power4.easeInOut });
      } else {
        bodyTL.fromTo(this.$refs.offcanvas, 1, { width: '62%' }, { width: '100%', ease: Power4.easeInOut });
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/app.scss';
</style>
